import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Svg } from "../Svg";

import styles from "./index.module.scss";

export const LogoLoader = ({ className }: { className?: string }) => (
    <div
        className={concatClassNames([styles.root, className])}
        aria-hidden="true"
    >
        <Svg name="logo-h" />
    </div>
);
